const notificationCenter = {
  pageTitle: "Notification center",
  loading: "Loading notifications",
  tabs: {
    reporting: "Reporting",
    messages: "Messages",
    cases: "Cases",
    chargeInvoices: "Charge invoices",
    product: "Product",
    settings: "Settings",
    deadlines: "Deadlines",
  },
  sections: {
    reporting: {
      main: "Reporting",
    },
    messages: {
      main: "Messages",
    },
    cases: {
      main: "Cases",
    },
    chargeInvoices: {
      main: "Charge invoices",
    },
    product: {
      main: "Product",
    },
    settings: {
      main: "Settings",
    },
    deadlines: {
      main: "Deadlines",
    },
  },
  columns: {
    company: "Company",
    countryJurisdiction: "Country/Jurisdiction",
    typeOfReport: "Type of report",
    dueDate: "Due date",
    type: "Type",
    subject: "Subject",
    status: "Status",
    dateLastStatusChanged: "Date last status changed",
    generatedBy: "Generated by",
    app: "App",
    description: "Description",
    amount: "Amount",
    typeOfNumber: "Type of number",
    jurisdiction: "Jurisdiction",
    date: "Date",
    companiesList: "Companies list",
    actions: "Actions",
  },
  actions: {
    openRequest: "Open request",
    delete: "Delete",
  },
  filters: {
    showAll: "Show all",
  },
  empty: {
    title: "No notifications",
    description: "There are no items in this section.",
    tabPlaceholder: "This section will be available soon.",
    noTablesForRole: "No notification sections are available for your account.",
  },
};

export default notificationCenter;
